import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function ViewersBar() {
  const [viewers, setViewers] = useState(38);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 2000);
    return () => clearTimeout(timer);
  }, []);
  useEffect(() => {
    const interval = setInterval(() => {
      setViewers(prev => prev + (Math.random() > 0.5 ? 1 : -1));
    }, 4000);
    return () => clearInterval(interval);
  }, []);
  return <AnimatePresence data-id="element-351">
      {visible && <motion.div initial={{
      y: 100
    }} animate={{
      y: 0
    }} exit={{
      y: 100
    }} className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[1400] pointer-events-none" data-id="element-352">
          <div className="bg-[#1C1C2E]/90 backdrop-blur text-white px-4 py-2 rounded-full text-xs font-medium shadow-lg flex items-center gap-2 border border-white/10" data-id="element-353">
            <span className="relative flex h-2 w-2" data-id="element-354">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75" data-id="element-355"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-green-500" data-id="element-356"></span>
            </span>
            {viewers} personas leyendo ahora
          </div>
        </motion.div>}
    </AnimatePresence>;
}